<template>
  <el-drawer :append-to-body="appendToBody" :visible="visible" :direction="direction" :size="hidden ? '0' : mySize"
    :withHeader="false" :wrapperClosable="wrapperClosable" :destroy-on-close="destroyOnClose" :z-index="dynamicZIndex"
    :modal="modal && !hidden" :before-close="beforeClose" :close-on-press-escape="closeOnPressEscape"
    custom-class="l-drawer" @open="openDrawer" @opened="openedDrawer" @close="closeDrawer" @closed="closedDrawer">
    <div :class="['l-drawer--warpper', customClass]" v-loading="loading" :element-loading-text="loadingText"
      v-show="!hidden">
      <div class="l-drawer--body" :style="{ 'padding-bottom': showClose || showOk ? '48px' : '0' }">
        <el-input style="position: absolute; top: -200px"></el-input>
        <div class="l-rblock">
          <slot></slot>
        </div>
        <div class="l-drawer-bottom-btns" v-if="showClose || showOk">
          <el-button v-if="showClose" size="mini" @click="handleClose">{{
            closeBtnLabel
          }}</el-button>
          <slot name="btns"> </slot>
          <el-button v-if="showOk" size="mini" type="primary" @click="handleOk">{{ okBtnLabel }}</el-button>
        </div>
      </div>
      <div v-if="withHeader" class="l-drawer--header">
        <slot name="header">
          <div class="l-drawer--title">{{ $t(title) }}</div>
          <div class="l-drawer--btns">
            <el-button size="mini" type="text" class="learun-close-icon-btn" icon="el-icon-close"
              @click="handleClose"></el-button>
          </div>
        </slot>
      </div>
    </div>
  </el-drawer>
</template>
<script>
export default {
  name: "l-drawer",
  props: {
    title: String,
    visible: {
      type: Boolean,
    },
    direction: {
      type: String,
      default: "rtl",
      validator(val) {
        return ["ltr", "rtl", "ttb", "btt"].indexOf(val) !== -1;
      },
    },
    size: {
      type: String,
      default: "600px",
    },
    width: Number,
    modal: {
      type: Boolean,
      default: true,
    },
    destroyOnClose: {
      type: Boolean,
      default: true,
    },
    withHeader: {
      type: Boolean,
      default: true,
    },

    showClose: {
      type: Boolean,
      default: true,
    },
    showOk: {
      type: Boolean,
      default: true,
    },
    okBtnLabel: {
      type: String,
      default: "确定",
    },
    closeBtnLabel: {
      type: String,
      default: "取消",
    },
    customClass: String,
    appendToBody: {
      type: Boolean,
      default: true,
    },
    zIndex: {
      type: Number,
      default: 10000,
    },
    beforeClose: Function,
    closeOnPressEscape: {
      type: Boolean,
      default: true,
    },
    wrapperClosable: {
      type: Boolean,
      default: false,
    },

    isStep: {
      type: Boolean,
      default: false,
    },
    stepActive: {
      type: Number,
      default: 0,
    },
    steps: {
      type: Array,
      default: () => [],
    },
    validateSteps: Function,
    hidden: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      loadingText: "",
      dynamicZIndex: this.zIndex,
    };
  },
  mounted() { },
  beforeDestroy() {
    this.releaseZIndex();
    // 确保从 DOM 中移除
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  computed: {
    mySize() {
      return this.width ? `${this.width}px` : this.size;
    },
  },
  watch: {
    // 监听 visible，当抽屉打开时重新计算层级，关闭时恢复默认层级
    visible: {
      handler(newVal) {
        if (newVal) {
          this.updateZIndexBeforeOpen();
        } else {
          this.releaseZIndex();
          this.resetZIndex();
        }
      },
      immediate: true, // 立即执行一次，以防 visible 初始为 true
    },
    // 如果父组件主动修改了 zIndex，也同步到 dynamicZIndex
    zIndex(newVal) {
      if (this.visible) {
        this.updateZIndexBeforeOpen();
      } else {
        this.dynamicZIndex = newVal;
      }
    },
  },
  methods: {
    resetZIndex() {
      this.$nextTick(() => {
        this.dynamicZIndex = this.zIndex;
      });
    },
    getLayerManager() {
      if (!window.lrPopupLayerManager) {
        window.lrPopupLayerManager = {
          baseZIndex: 10000,
          currentZIndex: 10000,
          layers: {},
          nextZIndex(suggested = 0) {
            const layerMax = Object.values(this.layers).reduce(
              (max, z) => (typeof z === 'number' && z > max ? z : max),
              0
            );
            const target = Math.max(this.currentZIndex, layerMax, suggested, this.baseZIndex);
            this.currentZIndex = target + 1;
            return this.currentZIndex;
          },
          register(id, z) {
            if (id) {
              this.layers[id] = z;
            }
          },
          release(id) {
            if (id && this.layers[id] !== undefined) {
              delete this.layers[id];
            }
            if (Object.keys(this.layers).length === 0) {
              this.currentZIndex = this.baseZIndex;
            }
          }
        };
      }
      return window.lrPopupLayerManager;
    },
    getMaxDomZIndex() {
      let maxZ = 0;
      const nodes = document.querySelectorAll('.el-dialog__wrapper, .el-drawer__wrapper, .v-modal');
      nodes.forEach(el => {
        const z = parseInt(window.getComputedStyle(el).zIndex, 10);
        if (!isNaN(z) && z > maxZ) {
          maxZ = z;
        }
      });
      return maxZ;
    },
    updateZIndexBeforeOpen() {
      const manager = this.getLayerManager();
      const suggested = Math.max(this.getMaxDomZIndex(), this.zIndex || 0);
      const newZ = manager.nextZIndex(suggested);
      manager.register(this._layerId || (this._layerId = `lr-drawer-${Date.now()}-${Math.random().toString(16).slice(2)}`), newZ);
      this.dynamicZIndex = newZ;
    },
    releaseZIndex() {
      if (!this._layerId) {
        return;
      }
      const manager = this.getLayerManager();
      manager.release(this._layerId);
      this._layerId = null;
    },
    handleClose() {
      this.$emit("update:visible", false);
    },
    handleOk() {
      this.$emit("ok", this.showLoading, this.hideLoading);
    },
    closeDrawer() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
    closedDrawer() {
      this.releaseZIndex();
      this.resetZIndex();
      this.$emit("closed");
    },
    openDrawer() {
      this.$emit("open");
    },
    openedDrawer() {
      this.$emit("opened", this.showLoading, this.hideLoading);
    },
    showLoading(text) {
      this.loadingText = text || "保存数据中...";
      this.loading = true;
    },
    hideLoading() {
      this.loading = false;
    },
  },
};
</script>
<style lang="less">
@import "./index.less";
</style>
